import type { ReactNode } from 'react';

type SectionCardProps = {
  title: string;
  children: ReactNode;
  right?: ReactNode;
};

const SectionCard = ({ title, children, right }: SectionCardProps) => {
  return (
    <div
      className="overflow-hidden rounded-sm border border-[#DADADA] bg-white"
      style={{ boxShadow: '4px 4px 15px 0 rgba(0, 0, 0, 0.15)' }}
    >
      <div className="flex items-center justify-between bg-text-primary px-4 py-2">
        <div className="text-sm font-semibold text-white">{title}</div>
        {right}
      </div>
      <div className="px-4 py-3">{children}</div>
    </div>
  );
};

export default SectionCard;
